/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-10-30T15:20:00+05:00
Intent: Escape text typed by clients (campaign names, descriptions…) before it is put into HTML, so it shows exactly as typed and is never run as markup.
*/

const HTML_ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** The text as safe HTML: tags such as `<b>` or `<script>` come out as visible characters. */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[&<>"']/g, (ch) => HTML_ENTITIES[ch]);
}
